// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3_ti4","productName":"Table_productName__3wwqA"};